<template>
  <section
    v-if="options !== null"
    v-cloak
    id="policies"
    data-test-policy-section-new
    data-test-component="policySection"
  >
    <div class="container">
      <div class="row columns">
        <h1 v-html="options.policySectionTitle" />
      </div>
    </div>
    <div v-if="options.isPolicyListEmpty">
      <div class="container">
        <div class="row columns">
          <p v-html="options.policySectionEmptyText" />
        </div>
      </div>
    </div>
    <div v-else>
      <ul class="accordion policy-accordion">
        <li
          v-for="(policy, index) in options.policies"
          :key="'policy-' + index"
          data-test-policy-section
          :data-test-policy-id="policy.policyNumber"
          :class="'accordion-item policy-status-' + policy.policyActiveStatusEnumString"
          :data-info="
            setDataInfo(
              policy.policyNumber,
              policy.productVersionId,
              policy.policyActiveStatusEnumString
            )
          "
        >
          <div class="container">
            <div class="row column">
              <!-- Policy Level 1 -->
              <div
                :id="policy.externalPolicyNumber"
                class="accordion-title"
                data-test-policy-section-view-lv-1
                @click="togglePolicyLevel2(policy.productName.toLowerCase(), policy.policyNumber)"
              >
                <level-one :policy-info="policy" />
              </div>
              <!-- Policy Level 2 -->
              <level-two :policy-info="policy" />
            </div>
          </div>

          <div v-if="policy.hasRenewal" data-test-policy-renewal-section>
            <div
              class="container row renewal"
              :data-info="
                setDataInfo(
                  policy.renewalInformation.policyNumber,
                  policy.renewalInformation.productVersionId,
                  policy.renewalInformation.policyActiveStatusEnumString
                )
              "
            >
              <div class="small-12 columns">
                <div class="info-box info-box-align-left is-shown">
                  <div class="row">
                    <div class="small-3 medium-2 large-1 columns">
                      <span class="icon icon-info" />
                    </div>
                    <div
                      data-test-policy-renewal-information
                      class="small-9 medium-10 large-7 columns"
                      v-html="policy.renewalInformation.informationText"
                    />
                    <div class="small-12 medium-12 large-4 columns">
                      <a
                        data-test-policy-renewal-button
                        :href="policy.renewalInformation.policyDetailsPageButtonUrl"
                        class="button"
                        @click="trackEditBtn"
                        v-html="policy.renewalInformation.buttonLabel"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import LevelOne from './LevelOne.vue';
import LevelTwo from './LevelTwo.vue';

export default {
  name: 'PolicySection',
  components: {
    LevelOne,
    LevelTwo
  },
  props: {
    options: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    togglePolicyLevel2(name, policyNumber) {
      // setTimeout to allow accordion time to set is-active class on list element
      setTimeout(() => {
        const listItem = document.querySelector(`[data-test-policy-id="${policyNumber}"]`);
        const { className } = listItem;
        const isActive = className.search('is-active') > 0;

        if (isActive) {
          return this.$store.dispatch('Events/register', {
            event: `policy-section-click-policy-details-button-${name}`,
            id: 'policySection',
            vm: this
          });
        }
      }, 100);
    },
    setDataInfo(number, version, status) {
      return `pn: ${number} pv: ${version} status: ${status}`;
    },
    trackEditBtn() {
      this.$store.dispatch('Events/register', {
        event: 'policy-section-click-edit-future-policy',
        id: 'policySection'
      });
    }
  }
};
</script>
